/* eslint-disable camelcase */
import axios from 'axios';

import { GROUP_INDEXING_RULE_ENDPOINT } from '@dynameat/constants';

export const groupIndexingRuleListRequest = (point_of_sale__guid) => axios.get(
  GROUP_INDEXING_RULE_ENDPOINT(), { params: { point_of_sale__guid } }
);

export const createGroupIndexingRuleRequest = (groupIndexingRule) => axios.post(
  GROUP_INDEXING_RULE_ENDPOINT(), groupIndexingRule
);

export const updateGroupIndexingRuleRequest = (groupIndexingRule) => axios.patch(
  GROUP_INDEXING_RULE_ENDPOINT(groupIndexingRule.guid), groupIndexingRule
);

export const removeGroupIndexingRuleRequest = (groupIndexingRuleGuid) => axios.delete(
  GROUP_INDEXING_RULE_ENDPOINT(groupIndexingRuleGuid)
);
